import * as React from 'react';
import { styled } from '@glitz/react';
import { useIsLoading } from '@avensia/excite';
import { FadeAnimation, createTransitionDecorator, createAnimationDecorator } from '@avensia/excite-ui';
import { ZIndex } from '../z-index';

const PROGRESS_MAX = 0.9;
const PROGRESS_FACTOR = 0.7;
const PROGRESS_INTERVAL = 500;

type PropType = {
  black?: boolean;
};

export function PageLoader(props: PropType) {
  const isLoading = useIsLoading();
  const [visible, setVisible] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  React.useEffect(() => {
    // Fake loading progress
    if (isLoading) {
      setProgress(0);
      setVisible(true);

      const timeout = setInterval(() => {
        setProgress(progress => PROGRESS_MAX - (PROGRESS_MAX - progress) * PROGRESS_FACTOR);
      }, PROGRESS_INTERVAL);

      return () => {
        clearInterval(timeout);
        setProgress(progress => (progress > 0 ? 1 : 0));
        setVisible(false);
      };
    }
  }, [isLoading]);

  return (
    <Progress
      visible={visible}
      style={{ transform: `scaleX(${progress})`, filter: `invert(${props.black ? 1 : 0})` }}
    />
  );
}

const Progress = styled(
  FadeAnimation,
  createTransitionDecorator({ property: 'transform', duration: PROGRESS_INTERVAL, timingFunction: 'linear' }),
  createAnimationDecorator({
    name: { from: { backgroundPositionX: '100%' }, to: { backgroundPositionX: '0%' } },
    duration: 2000,
    timingFunction: 'linear',
    iterationCount: 'infinite',
  }),
  {
    position: 'fixed',
    zIndex: ZIndex.Spinner,
    top: 0,
    left: 0,
    width: '100%',
    height: 1,
    pointerEvents: 'none',
    transformOrigin: 'left top',
    background: {
      image: `linear-gradient(to left, rgba(255, 255, 255, 0.25) 33%, rgba(255, 255, 255, .5) 50%, rgba(255, 255, 255, 0.25) 67%)`,
      size: '300%',
    },
  },
);
